import React, { useState, useEffect } from 'react'
import { getCategories, list } from './ApiCore'
import Card from './Card'

const Search = () => {
    const [data, setData] = useState({
        categories: [],
        category: '',
        search: '',
        results: [],
        searched: false
    })

    const { categories, category, search, results, searched } = data

    const loadCategories = () => {
        getCategories().then(data => {
            if (data.error) {
                console.log(data.error)
            }
            else {
                setData({ ...data, categories: data })
            }
        })
    }

    useEffect(() => {
        loadCategories()
    }, [])

    const searchData = () => {
        console.log(search, category)
        if (search) {
            list({ search: search || undefined, category: category })
                .then(response => {
                    if (response.error) {
                        console.log(response.error)
                    } else {
                        setData({ ...data, results: response, searched: true })
                    }
                })
        } else {
            setData({ ...data, results: [], searched: false })
        }
    }

    const searchSubmit = (e) => {
        e.preventDefault()
        searchData()
    }

    const handleChange = name => event => {
        setData({ ...data, [name]: event.target.value, searched: false })
    }

    const searchMessage = (searched, results) => {
        if (searched && results.length > 0) {
            return `Found ${results.length} Products`
        }
        if (searched && results.length < 1) {
            return 'No products found!'
        }
    }

    const searchedProducts = (results = []) => {
        return (
            <div>
                <h2 className="mt-4 mb-4">
                    {searchMessage(searched, results)}
                </h2>
                <div className="row">
                    {results.map((product, i) => (
                        <div key={i} className="col-sm-6 col-lg-4 col-xl-3 mb-3">
                            <Card product={product} key={i} />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    const searchForm = () => (
        <form onSubmit={searchSubmit}>
            <span className="input-group-text">
                <div className="input-group ">
                    <div className="input-group-prepend">
                        <select className="btn mr-2" name="category" onChange={handleChange('category')}>
                            <option value="All">Pick Category</option>
                            {categories?.map((c, i) => (<option key={i} value={c._id}> {c.name} </option>))}
                        </select>
                    </div>
                    <input type="search" placeholder="Search by name" onChange={handleChange('search')} className="form-control" />
                </div>
                <div className="btn input-group-append" style={{ border: 'none' }}>
                    <button className="input-group-text">Search</button>
                </div>
            </span>
        </form>
    )

    return (
        <div className="row">
            <div className="container mb-3">{searchForm()}</div>
            <div className="container-fluid">
                {searchedProducts(results)}
            </div>
        </div>
    )
}

export default Search